import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderGeneralTraversalNode } from "../../actionHelpers/generalTraversal";
import { isWebsiteBuilderContainer } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { isWebsiteBuilderGrid } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderGrid";
import { cloneDeep } from "lodash";

export interface ISwapGridCellContentActionPayload {
  sectionId: string;
  gridId: string;
  elementId: string;
  prevGridCellId: string;
  nextGridCellId: string;
}

export interface ISwapGridCellContentAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT;
  payload: ISwapGridCellContentActionPayload;
}

export function getSwapGridCellContentInverseAction(action: ISwapGridCellContentAction): ISwapGridCellContentAction {
  const { sectionId, gridId, elementId, prevGridCellId, nextGridCellId } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      sectionId,
      gridId,
      elementId,
      prevGridCellId: nextGridCellId,
      nextGridCellId: prevGridCellId,
    },
  };
}

function swapGridCellContentTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  gridId: string,
  prevGridCellId: string,
  nextGridCellId: string,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: IWebsiteBuilderGeneralTraversalNode): IWebsiteBuilderGeneralTraversalNode {
    if (isWebsiteBuilderContainer(node)) {
      if (isWebsiteBuilderGrid(node) && node.id === gridId) {
        const updatedChildren = cloneDeep(node.children);

        const prevGridCell = updatedChildren.find(child => child.id === prevGridCellId);
        const nextGridCell = updatedChildren.find(child => child.id === nextGridCellId);

        if (prevGridCell == null || nextGridCell == null) {
          return node;
        } else {
          const temp = prevGridCell.children;
  
          prevGridCell.children = nextGridCell.children;
          nextGridCell.children = temp;
  
          return {
            ...node,
            children: updatedChildren,
          };
        }
      } else {
        return node;
      }
    } else {
      if (!node.children) {
        return node;
      } else {
        return {
          ...node,
          children: node.children.map(traverse),
        };
      }
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}

export function applySwapGridCellContentChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: ISwapGridCellContentAction,
): IWebsiteBuilderHistorySnapshot {
  const { gridId, prevGridCellId, nextGridCellId } = action.payload;

  return swapGridCellContentTraversal(header, root, footer, gridId, prevGridCellId, nextGridCellId);
}
